import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function CircleMinus(props: IconProps) {
  return (
    <IconSvg {...props} fillRule="evenodd">
      <path d="M34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2a16 16 0 0116 16zm-6 0a.75.75 0 01-.75.75H8.75a.75.75 0 010-1.5h18.5A.75.75 0 0128 18z"></path>
    </IconSvg>
  );
}
